import apiGroupsAthletes from '@/api/groups-athletes'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteGroupsAthletesStart:
    '[delete groups athletes] Delete groups athletes start',
  deleteGroupsAthletesSuccess:
    '[delete groups athletes] Delete groups athletes success',
  deleteGroupsAthletesFailure:
    '[delete groups athletes] Delete groups athletes failure'
}

export const actionTypes = {
  deleteGroupsAthletes: '[delete groups athletes] Delete groups athletes'
}

const mutations = {
  [mutationTypes.deleteGroupsAthletesStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteGroupsAthletesSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteGroupsAthletesFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteGroupsAthletes](context, {id}) {
    context.commit(mutationTypes.deleteGroupsAthletesStart)
    return new Promise(resolve => {
      apiGroupsAthletes
        .deleteGroupsAthlete(id)
        .then(response => {
          context.commit(mutationTypes.deleteGroupsAthletesSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteGroupsAthletesFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
